/* eslint-disable no-console */

import { register } from 'register-service-worker';

function RegisterServiceWorker() {
  if (process.env.NODE_ENV === 'production') {
    const isCleanupCompleted = localStorage.getItem('sw-cleanup-completed');

    if (isCleanupCompleted) {
      console.log('Service Worker Already Cleaned');
      return;
    }

    register(`${process.env.BASE_URL}service-worker.js`, {
      registrationOptions: {
        updateViaCache: 'none',
      },

      ready() {
        console.log('✨ 정리용 Service Worker 준비됨');
      },
      registered() {
        console.log('Service worker has been registered.');
      },
      cached() {
        console.log('Content has been cached for offline use.');
      },
      updatefound() {
        console.log('New content is downloading.');
      },
      updated() {
        console.log('New content is available; please refresh.');
      },

      offline() {
        console.log('오프라인 모드');
      },

      error(error) {
        console.error('Service Worker 정리 오류:', error);
      },
    });

    // ✅ 메시지 리스너 추가
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', event => {
        if (event.data && event.data.type === 'SW_CLEANUP_COMPLETE') {
          console.log('✅ Service Worker 정리 완료');

          // 로컬 스토리지에 정리 완료 표시
          localStorage.setItem('sw-cleanup-completed', Date.now().toString());

          // 사용자에게 알림
          console.log('다음 방문 시 Service Worker가 완전히 제거됩니다.');
        }
      });
    }
  } else {
    console.log('개발 모드: Service Worker 비활성화');
  }
}

RegisterServiceWorker();
